import logo from "./woodstock.png";
import "./App.css";
import React, { useRef, useEffect, useState } from "react";
import {
	Grid,
	TextField,
	Typography,
	Button,
	Select,
	MenuItem,
	InputLabel,
	FormControl,
} from "@mui/material";
import { BrowserRouter as Router, useHistory } from "react-router-dom";
import Helmet from "react-helmet";
import Content from "./content";
import Header from "./header";
import skogsklass from "./skogsklass";
import fastighetsklass from "./fastighetsklass";
import ReturnTicketList from "./returnTicketList";
import renderMap from "./renderMap";
import PolygonEditor from "./components/PolygonEditor";
import Trädslagsklass from "./trädslagsklass";
import { LineChart, prepare_data } from "./tools/linechart";

//To do:
// - Fixa state problemet där bestånd & fält uppdateras, men inte re-renderas.
// - Spara bestånd i en JSON-fil
// - Ladda in bestånd från JSON-fil
// - Ta in information om kalkylränta
// - Ladda in diskonteringstabell, alt. skapa en funktion för att interpolera diskonteringstabellen

function App() {
	return (
		<div className="App">
			<header className="App-header" style={{ height: "2rem" }}>
				<img src={logo} className="App-logo" alt="logo" />
			</header>
			<div className="App-body">
				<PolygonEditor />
			</div>
			<Helmet
				titleTemplate="%s | Tågluffa i Europa"
				defaultTitle="Tågluffa i Europa"
			>
				<meta charSet="utf-8" />
				<meta
					name="description"
					content="Skogskalkyl - Forestry Management"
				/>
			</Helmet>
		</div>
	);
}

export default App;

/*
Domännamnsförslag
skogsvärdering.se
skogskalkyl.se
skogsbok.se
skogsverksamhet.se
skogsverksam.se
skogio.se
forestry.nu
forestery.se
forestery.nu
iwood.se
skogsodling.se
woodstock.nu
*/
